export default "__VITE_ASSET__Do4k3Ur9__"